<template>
  <div class="network-tabs">
    <div class="network-tabs-nav" role="tablist" aria-label="Network list tabs">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        type="button"
        class="network-tab"
        :class="{ 'is-active': activeTab === tab.key }"
        :aria-selected="activeTab === tab.key ? 'true' : 'false'"
        @click="activeTab = tab.key"
      >
        {{ tab.label }}
        <span class="network-tab-count">{{ tab.count }}</span>
      </button>
    </div>

    <div
      v-for="tab in tabs"
      :key="`panel-${tab.key}`"
      class="network-tab-panel"
      :class="{ 'is-active': activeTab === tab.key }"
      :style="{ display: activeTab === tab.key ? '' : 'none' }"
    >
      <table v-if="tab.key === 'vlan'" class="table table-striped table-bordered table-condensed">
        <thead>
          <tr>
            <th class="col-sm-3 col-md-3 col-lg-3"><div class="text-center">Network Name</div></th>
            <th class="col-sm-2 col-md-2 col-lg-2 hidden-tablet"><div class="text-center">IPv4</div></th>
            <th class="col-sm-2 col-md-2 col-lg-2 hidden-tablet"><div class="text-center">IPv6</div></th>
            <th class="col-sm-1 col-md-1 col-lg-1 hidden-phone"><div class="text-center">VLAN ID</div></th>
            <th class="col-sm-1 col-md-1 col-lg-1"><div class="text-center">Interface</div></th>
            <th class="col-sm-4 col-md-4 col-lg-4 hidden-tablet"><div class="text-center">Description</div></th>
            <th v-if="showVlanActions" class="col-sm-1 col-md-1 col-lg-1 network-actions-col"><div class="text-center">Operation</div></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in tab.rows || []" :key="`vlan-${row.id}`">
            <td><div class="text-center"><a :href="row.show_url">{{ row.name }}</a></div></td>
            <td class="hidden-tablet"><div class="text-center">{{ row.ipv4 }}</div></td>
            <td class="hidden-tablet"><div class="text-center">{{ row.ipv6 }}</div></td>
            <td class="hidden-phone"><div class="text-center">{{ row.vlan }}</div></td>
            <td><div class="text-center">{{ row.interface_name }}</div></td>
            <td class="hidden-tablet"><div class="text-center">{{ row.description }}</div></td>
            <td v-if="showVlanActions" class="nopadding network-actions-col" v-html="row.action_html"></td>
          </tr>
        </tbody>
      </table>

      <table v-else class="table table-striped table-bordered table-condensed">
        <thead>
          <tr>
            <th class="col-sm-3 col-md-3 col-lg-3"><div class="text-center">Network Name</div></th>
            <th class="col-sm-1 col-md-1 col-lg-1"><div class="text-center">VNI</div></th>
            <th class="col-sm-1 col-md-1 col-lg-1"><div class="text-center">Owner</div></th>
            <th class="col-sm-3 col-md-3 col-lg-4 hidden-tablet"><div class="text-center">Description</div></th>
            <th class="col-sm-1 col-md-1 col-lg-2 network-actions-col"><div class="text-center">Operation</div></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in tab.rows || []" :key="`vxlan-${row.id}`">
            <td><div class="text-center"><a :href="row.show_url">{{ row.name }}</a></div></td>
            <td><div class="text-center">{{ row.vni }}</div></td>
            <td><div class="text-center">{{ row.owner }}</div></td>
            <td class="hidden-tablet"><div class="text-center">{{ row.description }}</div></td>
            <td class="nopadding network-actions-col" v-html="row.action_html"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

const props = defineProps({
  tabs: {
    type: Array,
    default: () => []
  }
})

const activeTab = ref(props.tabs[0]?.key || '')
const showVlanActions = computed(() => (props.tabs.find((tab) => tab.key === 'vlan')?.rows || []).some((row) => row.action_html))
</script>
